import { getMobileBookingProgress } from '@components/BookingFlow/Common/bookingFlowProgress';
import { BookingStepUnavailablePage } from '@components/BookingFlow/Common/BookingStepUnavailablePage';
import { BookingScreen } from '@components/BookingFlow/Mobile/BookingScreen';
import { t } from '@lingui/core/macro';
import { commonTrackingEvents, tracking, useBookingAddress, useBookingTimeWindow } from 'noddi-web';
import { useNavigateToSummaryOrRequiredInfo } from '../../../../hooks/useRequiresInsuranceInfo';
import { TimeWindowPicker } from './TimeWindowPicker';

export const TimeWindow = () => {
  const selectedTimeWindow = useBookingTimeWindow();
  const selectedAddress = useBookingAddress();
  const navigateToSummaryOrRequiredInfo = useNavigateToSummaryOrRequiredInfo();

  const onNextClicked = () => {
    tracking.track(commonTrackingEvents.timeWindowStepCompleted, { startsAt: selectedTimeWindow?.startsAt });
    navigateToSummaryOrRequiredInfo();
  };

  // Slots are looked up per address, so guard before the step chrome mounts.
  if (!selectedAddress) {
    return <BookingStepUnavailablePage missing='address' />;
  }

  return (
    <BookingScreen
      progress={getMobileBookingProgress('time')}
      onNextClicked={onNextClicked}
      title={t`When is it convenient for us to come to you?`}
      width='lg'
      showSelectedTimeWindow
      hideShoppingCart
      disableNextButton={!selectedTimeWindow}
      validationVariant='timeSlotRequired'
    >
      <TimeWindowPicker selectedAddress={selectedAddress} />
    </BookingScreen>
  );
};
